import React from "react";
import parser from "html-react-parser";
import CardsItem from "./CardsItem";
import TileItem from "./TileItem";

const Cards = ({
  cardsAlignCenter,
  cardsText,
  cardsTitle,
  cardsTitleAlign,
  cardsTitleHeadingLevel,
  items,
  layout,
  menu,
  numTileColumns,
  withinContainer,
}) => {
  const tileColumns = numTileColumns ?? 2;
  const cTitleHLevel = cardsTitleHeadingLevel ?? "h2";
  const cTitleAlign = cardsTitleAlign ?? "left";
  const cTitleHtml = `<${cTitleHLevel} className='text-${cTitleAlign}'>${cardsTitle}</${cTitleHLevel}>`;
  const elements = (
    <div className={"tps-related-top-level-wrapper"}>
      {cardsTitle && parser(cTitleHtml)}
      {cardsText && parser(cardsText)}
      {layout == "tiles" ? (
        <div
          className={`tps-card-listing tps-related-pages-compact tps-related-pages grid-x grid-margin-x grid-margin-y small-up-1 medium-up-2 large-up-${tileColumns}`}
          style={{ width: "auto" }}
        >
          {items.map((item, index) => {
            const fromPage =
              item?.page?.data?.attributes ||
              item?.news?.data?.attributes ||
              item?.course?.data?.attributes ||
              item?.concert?.data?.attributes;

            return (
              <TileItem
                buttonPage={item?.buttonPage?.data?.attributes}
                image={item?.image?.data?.attributes}
                key={index}
                menu={menu}
                tileColumns={tileColumns}
                linkText={item?.buttonText}
                linkUrl={item?.url}
                shortText={item?.shortText}
                title={item?.title}
                target={item?.target}
                page={item?.page}
                news={item?.news}
                course={item?.course}
                concert={item?.concert}
                fromPage={fromPage}
              />
            );
          })}
        </div>
      ) : (
        <div
          className={`tps-card-listing tps-related-pages-cards tps-related-pages grid-x 
        grid-margin-x grid-margin-y small-up-1 medium-up-2 large-up-4 align-left ${
          cardsAlignCenter ? "align-center" : ""
        }`}
        >
          {items.map((item, index) => {
            const fromPage =
              item?.page?.data?.attributes ||
              item?.news?.data?.attributes ||
              item?.course?.data?.attributes ||
              item?.concert?.data?.attributes;

            return (
              <CardsItem
                key={index}
                title={item?.title}
                shortText={item?.shortText}
                buttonPage={item?.buttonPage?.data?.attributes}
                buttonPage2={item?.buttonPage2?.data?.attributes}
                buttonText={item?.buttonText}
                buttonText2={item?.buttonText2}
                target={item?.target}
                target2={item?.target2}
                image={item?.image?.data?.attributes}
                url={item?.url}
                url2={item?.url2}
                date={item?.date}
                menu={menu}
                fromPage={fromPage}
                page={item?.page}
                news={item?.news}
                course={item?.course}
                concert={item?.concert}
              />
            );
          })}
        </div>
      )}
    </div>
  );

  return withinContainer ? (
    <div className={"grid-container"}>{elements}</div>
  ) : (
    elements
  );
};

export default Cards;
